import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class LoyaltyRedemptionRules {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-redemption-rules");

    if (!this.$el) {
      return;
    }

    this.$title = this.$el.querySelector(".js-loyalty-redemption-rules-title");
    this.$description = this.$el.querySelector(
      ".js-loyalty-redemption-rules-description"
    );
    this.$stage = this.$el.querySelector(".js-loyalty-redemption-rules-stage");
    this.$stageItems = this.$stage.querySelectorAll(
      ".js-loyalty-redemption-rules-stage-item"
    );

    this.isMobile = window.innerWidth <= 1024;
    this.animate();
  }

  animate() {
    const timelineOptions = {
      scrollTrigger: {
        trigger: this.$el,
        scrub: true,
        pin: !this.isMobile,
        end: "+=3000",
      },
    };

    if (this.isMobile) {
      timelineOptions.scrollTrigger.end = "bottom 100%";
    }

    const timeline = gsap.timeline(timelineOptions);
    const offset = 158;

    timeline
      .fromTo(
        this.$title,
        {
          opacity: 0.5,
        },
        {
          opacity: 1,
          duration: 2,
          ease: "expo.out",
        }
      )
      .fromTo(
        this.$description,
        {
          opacity: 0.5,
        },
        {
          opacity: 1,
          duration: 2,
          ease: "expo.out",
        },
        "-=2"
      );

    if (this.isMobile) {
      timeline.fromTo(
        this.$stage,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 2,
          ease: "expo.out",
        },
        "-=3"
      );
    } else {
      timeline.fromTo(
        this.$stage,
        {
          opacity: 0.5,
        },
        {
          opacity: 1,
          duration: 1,
          ease: "expo.out",
        },
        "0"
      );
      timeline.fromTo(
        this.$stage,
        {
          // move the stage to the center of the screen
          x: this.$stage.getBoundingClientRect().width / 2 + offset,
        },
        {
          x: -this.$stage.getBoundingClientRect().width / 2 - offset,
          duration: 2,
        },
        "-=1.5"
      );
    }
  }
}
